import moment from 'moment';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { getConcernByID, getDepartment, getPeople, postConcern, updateConcern } from '../../service/todo';
import { NotificationTrigger, OnlyNumberSpecialChar } from '../../utils/RegHandling';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import Loader from '../../StaticComponent/Loader';
import './css/Concern-form.css';
import { connect } from 'react-redux';
import _ from 'lodash';

import { encryptStorage } from '../../constant';

function ConcernForm({ websocket }) {
    let emp_id = encryptStorage.getItem('employeeId');
    let userID = (emp_id);

    let id, Mode, concern_type;
    let concernObj = {
        emp_id: emp_id,
        type: '1',
        departmentID: null,
        againstWhom: '',
        description: '',
        victim: '',
        victimName: '',
        incidentDate: '',
        location: '',
        id: '',
    };
    let peoplePicker = [];
    const { state } = useLocation();
    const navigate = useNavigate();
    const [departmentValidation, setDepartmentValidation] = useState('');
    const [personValidation, setPersonValidation] = useState('');
    const [friendNameValidation, setFriendNameValidation] = useState('');
    const [descriptionValidation, setDescriptionValidation] = useState('');
    const [dateValidation, setDateValidation] = useState('');
    const [locationValidation, setLocationValidation] = useState('');
    const [type, setType] = useState();
    const [concernDetails, setConcernDetails] = useState(concernObj);
    const [oldConcernDetails, setOldConcernDetails] = useState(concernObj);
    const [victimType, setVictimType] = useState('1');
    const [department, setDepartment] = useState([]);
    const [pagemode, setpagemode] = useState('false');
    const [SelectedPeopleList, setSelectedPeopleList] = useState([]);
    const [selectedFriend, setSelectedFriend] = useState();
    const [peoplePickerData, setPeoplePickerData] = useState([]);
    const [maxDate, setMaxDate] = useState();
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [role, setrole] = useState(encryptStorage.getItem('role'));
    const max_date = new Date();
    let breadCrumbsData;

    const [disabledCheck, setDisabledCheck] = useState(false);

    useEffect(() => {
        loadDepartment();
        LoadConcernEditView();
        setMaxDate(moment(max_date).format('YYYY-MM-DD'));
    }, []);

    useEffect(() => {
        loadpeoplepicker('');
    }, [type]);

    useEffect(() => {
        if (state?.way == 'HowDoI' || state?.way == 'MyProfile') setType(1);
        else setType(state?.concernDetails?.type);
        LoadConcernEditView();
    }, [state?.concernDetails?.concern_id]);

    useEffect(() => {
        let isSame = _.isEqual(concernDetails, oldConcernDetails);
        if (state?.concernDetails?.concern_id && isSame) setDisabledCheck(true);
        else if (!isSame) setDisabledCheck(false);
    }, [concernDetails, oldConcernDetails, disabledCheck]);

    const LoadConcernEditView = async () => {
        try {
            id = state?.concernDetails?.concern_id;
            Mode = state?.concernDetails?.pMode;
            if (state?.way == 'HowDoI') concern_type = 1;
            else concern_type = state?.concernDetails?.type;
            if (Mode === 'edit') {
                setpagemode('true');
                selecteditarray(id, concern_type);
            }
        } catch (error) {}
    };

    const selecteditarray = async (id, type) => {
        let peoples,
            list = [],
            personId = [];
        setIsLoading(false);
        let responsedata = await getConcernByID({ concern_id: id, type: type });

        if (responsedata?.data.length > 1) {
            responsedata?.data.map((obj) => {
                peoples = {
                    value: obj.person_involved,
                    username: obj.against,
                    label: obj.against,
                };
                list.push(peoples);
            });
            setSelectedPeopleList(list);
        } else {
            peoples = {
                value: responsedata?.data[0]?.person_involved,
                username: responsedata?.data[0]?.against,
                label: responsedata?.data[0]?.against,
            };
            setSelectedPeopleList(peoples);
        }

        if (list.length > 0) {
            for (const item of list) {
                personId.push(item.value);
            }
        } else {
            personId.push(peoples.value);
        }

        let m = moment(new Date(responsedata?.data[0]?.incident_date));
        let date = m.format('YYYY-MM-DD');
        let valiDateobj = {
            id: id,
            type: responsedata?.data[0]?.concern_type_id,
            departmentID: responsedata?.data[0]?.department_id,
            description: responsedata?.data[0]?.description,
            victim: responsedata?.data[0]?.victim,
            incidentDate: date,
            location: responsedata?.data[0]?.location,
            victimName: responsedata?.data[0]?.victim_name,
            emp_id: emp_id,
            againstWhom: personId,
        };
        let affected_person = {
            value: responsedata?.data[0]?.victim_name,
            username: responsedata?.data[0]?.affected_person,
            label: responsedata?.data[0]?.affected_person,
        };
        setSelectedFriend(affected_person);

        setConcernDetails(valiDateobj);
        setOldConcernDetails(valiDateobj);
        setVictimType(responsedata?.data[0]?.victim);
        setIsLoading(true);
    };

    const loadpeoplepicker = async (department) => {
        peoplePicker = await getPeople(department);

        let samplearray = [];
        let temparray = peoplePicker?.data;
        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,
                label: temparray[i].emp_name,
                username: temparray[i].emp_name,
            };
            samplearray.push(objresponse);
        }
        setPeoplePickerData(samplearray);
    };

    const loadDepartment = async () => {
        setIsLoading(false);
        let deptArray = await getDepartment();
        setDepartment(deptArray?.data);
        setIsLoading(true);
    };

    const bindDepartment = () => {
        return department?.map((obj, index) => {
            return <option value={obj.department}>{obj.department}</option>;
        });
    };

    const handleRadio = (value) => {
        concernObj = {
            emp_id: emp_id,
            type: value,
            departmentID: null,
            againstWhom: [],
            description: '',
            victim: victimType,
            victimName: '',
            incidentDate: '',
            location: '',
            id: state?.concernDetails?.concern_id,
        };
        setSelectedPeopleList([]);
        setType(value);
        setConcernDetails(concernObj);
        setDepartmentValidation('');
        setDescriptionValidation('');
        setLocationValidation('');
        setPersonValidation('');
        setDateValidation('');
        setFriendNameValidation('');
    };

    const handleVictim = (e) => {
        let victimType = e.target.value;
        concernObj = {
            emp_id: emp_id,
            type: type,
            departmentID: null,
            againstWhom: [],
            description: '',
            victim: victimType,
            victimName: '',
            incidentDate: '',
            location: '',
            id: '',
        };
        setSelectedPeopleList([]);
        setSelectedFriend([]);
        setVictimType(victimType);
        setConcernDetails(concernObj);
        setDepartmentValidation('');
        setDescriptionValidation('');
        setLocationValidation('');
        setPersonValidation('');
        setDateValidation('');
        setFriendNameValidation('');
    };

    const handleInput = (e) => {
        setDepartmentValidation('');
        setDescriptionValidation('');
        setLocationValidation('');
        setDateValidation('');
        if (e.target.name == 'departmentID') {
            setSelectedDepartment(e.target.value);
            loadpeoplepicker(e.target.value);
            setConcernDetails({ ...concernDetails, [e.target.name]: e.target.value });
        } else {
            setConcernDetails({ ...concernDetails, [e.target.name]: e.target.value });
        }
    };

    const validation = () => {
        if (concernDetails.type != '3') {
            if (concernDetails.type == '1') {
                let result = true;
                if (concernDetails.departmentID == '' || concernDetails.departmentID == null) {
                    result = false;
                    setDepartmentValidation('Department is required');
                }
                if (SelectedPeopleList.length == 0) {
                    result = false;
                    setPersonValidation('Feedback to Whom? is required');
                }
                if (concernDetails.description == '') {
                    result = false;
                    setDescriptionValidation('Feedback is required');
                } else {
                    let checkregex = OnlyNumberSpecialChar(concernDetails.description);
                    if (checkregex) {
                        result = false;
                        setDescriptionValidation('Description is not valid');
                    } else {
                        setDescriptionValidation('');
                    }
                }
                // if (concernDetails.departmentID != null && SelectedPeopleList.length != 0 && concernDetails.description != ''){
                //     submitClick()
                // }
                if (result) submitClick();
            } else {
                let result = true;
                if (concernDetails.departmentID == '' || concernDetails.departmentID == null) {
                    result = false;
                    setDepartmentValidation('Department is required');
                }
                if (SelectedPeopleList.length == 0) {
                    result = false;
                    setPersonValidation('Concerns to Whom? is required');
                }
                if (concernDetails.description == '') {
                    result = false;
                    setDescriptionValidation('Concern Description is required');
                } else {
                    let checkregex = OnlyNumberSpecialChar(concernDetails.description);
                    if (checkregex) {
                        result = false;
                        setDescriptionValidation('Please enter a valid description');
                    } else {
                        setDescriptionValidation('');
                    }
                }
                // if (concernDetails.departmentID != null && SelectedPeopleList.length != 0 && concernDetails.description != ''){
                //     submitClick()
                // }
                if (result) submitClick();
            }
        } else if (concernDetails.victim != '2') {
            let result = true;
            concernDetails.victimName = emp_id;
            if (concernDetails.location == '') {
                result = false;
                setLocationValidation('Location is required');
            }
            if (concernDetails.incidentDate == '') {
                result = false;
                setDateValidation('Date is required');
            }
            if (SelectedPeopleList.length == 0) {
                result = false;
                setPersonValidation('People Involved in the incident is required');
            }
            if (concernDetails.description == '') {
                result = false;
                setDescriptionValidation('Description of the incident is required');
            } else {
                let checkregex = OnlyNumberSpecialChar(concernDetails.description);
                if (checkregex) {
                    result = false;
                    setDescriptionValidation('Please enter a valid description');
                } else {
                    setDescriptionValidation('');
                }
            }
            // if (concernDetails.location != '' && SelectedPeopleList.length != 0 && concernDetails.description != '' && concernDetails.incidentDate != ''){
            //     submitClick()
            // }
            if (result) submitClick();
        } else {
            let result = true;
            concernDetails.incidentDate = moment();
            if (concernDetails.departmentID == '' || concernDetails.departmentID == null) {
                result = false;
                setDepartmentValidation('Department is required');
            }
            if (concernDetails.location == '') {
                result = false;
                setLocationValidation('Location is required');
            }
            if (selectedFriend.length == 0) {
                result = false;
                setFriendNameValidation('Friend Name is required');
            }
            if (SelectedPeopleList.length == 0) {
                result = false;
                setPersonValidation('People Involved in the incident is required');
            }
            if (concernDetails.description == '') {
                result = false;
                setDescriptionValidation('Description of the incident is required');
            } else {
                let checkregex = OnlyNumberSpecialChar(concernDetails.description);
                if (checkregex) {
                    result = false;
                    setDescriptionValidation('Please enter a valid description');
                } else {
                    setDescriptionValidation('');
                }
            }
            // if (concernDetails.departmentID != null && SelectedPeopleList.length != 0 && selectedFriend.length != 0 &&
            //     concernDetails.description != '' && concernDetails.location != ''){
            //     submitClick()
            // }
            if (result) submitClick();
        }
    };

    const submitClick = async () => {
        //debugger;
        if (pagemode === 'true') {
            setIsLoading(false);
            let response = await updateConcern(concernDetails);

            setIsLoading(false);

            if (response?.message == 'Data Updated Successfully') {
                if (concernDetails.type) {
                    NotificationTrigger(
                        {
                            title: 'Concern',
                            message: 'Concern has been updated',
                            /* route: `leavewfh/` , */
                            route: 'concernView/',
                            state: { state: { concern: { type: concernDetails.type, concern_id: response.data[0].id , way : 1 } } },
                            to_employee: response?.reportsTo,
                            by: emp_id,
                        },
                        response?.reportsTo,
                        websocket
                    ).then((res) => {
                        redirect();
                    });
                }
                // else if (concernDetails.type == '2' || concernDetails.type == '3') {

                //     NotificationTrigger({
                //         title: "Concern", message: 'Updated the Concern',
                //         /* route: `leavewfh/` , */
                //         route: `/concerns`,
                //         to_employee: [response?.data.body.hrIncharge],
                //         by: emp_id
                //     }, [response?.data.body.hrIncharge]).then(res =>

                //         redirect()
                //     )

                // }
            }
        } else {
            setIsLoading(false);

            let response = await postConcern(concernDetails);

            setIsLoading(true);

            if (response?.message == 'Data inserted Successfully') {
                if (concernDetails.type) {
                    NotificationTrigger(
                        {
                            title: 'Concern',
                            message: 'Concern has been raised',
                            /* route: `leavewfh/` , */
                            route: `concernview/`,
                            to_employee: response?.reportsTo,
                            state: { state: { concern: { type: concernDetails.type, concern_id: response.data[0].id, way: 1 } } },
                            by: emp_id,
                        },
                        response?.reportsTo,
                        websocket
                    ).then((res) => redirect());
                }
                // else if (concernDetails.type == '2' || concernDetails.type == '3') {
                //     NotificationTrigger({
                //         title: "Concern", message: 'Raised a Concern',
                //         /* route: `leavewfh/` , */
                //         route: `/concerns`,
                //         to_employee: [response?.data.body.hrIncharge],
                //         by: emp_id
                //     }, [response?.data.body.hrIncharge]).then(res =>

                //         redirect()
                //     )

                // }
            }
        }
    };

    const
        redirect = () => {
        if (state?.way == 'MyProfile') {
            window.location.href = `/profilecontainer?EmpId=${userID}&IsTeamMember=true`;
        } else {
            navigate(`/concerns`);
        }
    };

    const handleChange = (e) => {
        setPersonValidation('');
        let selectedValue,
            tempArray = [];
        let attend = [];
        selectedValue = e;
        e.map((data) => {
            attend.push(data.value);
        });
        setSelectedPeopleList(selectedValue);
        for (let i = 0; i < selectedValue.length; i++) {
            tempArray.push(selectedValue[i].value);
        }

        if (tempArray.filter((el) => el != oldConcernDetails.againstWhom).length)
            setConcernDetails({ ...concernDetails, againstWhom: tempArray });
        else setConcernDetails({ ...concernDetails, againstWhom: oldConcernDetails.againstWhom });
    };

    const handleOnChange = (e) => {
        setFriendNameValidation('');
        let selectedValue,
            tempArray = [];
        let attend = [];
        selectedValue = e;
        e.map((data) => {
            attend.push(data.value);
        });
        setSelectedFriend(selectedValue);
        for (let i = 0; i < selectedValue.length; i++) {
            tempArray.push(selectedValue[i].value);
        }
        setConcernDetails({ ...concernDetails, victimName: tempArray[0] });
    };

    if (role === 'Team Member' && state?.way === 'MyProfile') {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/Overview', isActive: true },
            { title: 'My Profile', path: `/profilecontainer?EmpId=${userID}&IsTeamMember=true`, isActive: true },
            { title: 'Raise a Concern', path: '', isActive: false },
        ];
    } else if (state?.way === 'HowDoI') {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/Overview', isActive: true },
            { title: 'How Do I', path: '', isActive: true },
            { title: 'Concerns', path: '/concerns', isActive: true },
            { title: 'Raise a Concern', path: '', isActive: false },
        ];
    } else if (role === 'Team Member') {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/Overview', isActive: true },
            { title: 'How Do I', path: '', isActive: true },
            { title: 'Concerns', path: '/concerns', isActive: true },
            { title: 'Raise a Concern', path: '', isActive: false },
        ];
    } else {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/Overview', isActive: true },
            { title: 'Team Member', path: '', isActive: true },
            { title: 'Concerns', path: '/concerns', isActive: true },
            { title: 'Raise a Concern', path: '', isActive: false },
        ];
    }

    return (
        <div>
            <Loader isLoading={isLoading} />
            <div className="container-fluid coverpic body-bg mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-9 p-4 mt-5 bg-white rounded-3">
                        <BreadCrumbs data={breadCrumbsData} />
                        <p className="font-15 tt-bold concern-form-label">Raise a Concern</p>
                        {/*Form structure starts Here*/}
                        <label className="form-label hive-form-label " style={{ marginBottom: '25px !important' }}>
                            What is your concern about? <span className="required">*</span>
                        </label>
                        <div className="d-flex mt-3">
                            <input
                                onClick={(e) => {
                                    handleRadio('1');
                                }}
                                type="radio"
                                checked={type == 1 ? true : false}
                                className="me-2 mt-0 form-check-input custom-radio-btn"
                                name="type"
                                id="feedback"
                            />
                            <label className="form-check-label font-13 semibold-text me-3" htmlFor="feedback">
                                Feedback
                            </label>

                            <input
                                onClick={(e) => {
                                    handleRadio('2');
                                }}
                                type="radio"
                                checked={type == 2 ? true : false}
                                className="me-2 mt-0 form-check-input custom-radio-btn"
                                id="lead/manager"
                                name="type"
                            />
                            <label className="font-13 form-check-label semibold-text me-3" htmlFor="lead/manager">
                                Concern with Lead/Manager
                            </label>

                            <input
                                onClick={(e) => {
                                    handleRadio('3');
                                }}
                                type="radio"
                                checked={type == 3 ? true : false}
                                className="me-2 mt-0 form-check-input custom-radio-btn"
                                id="harassement"
                                name="type"
                            />
                            <label className="font-13 form-check-label semibold-text me-3" htmlFor="harassement">
                                Harassement Issue
                            </label>
                        </div>
                        {/*Form structure ends Here*/}
                    </div>
                    {type == 1 ? (
                        <div class="col-md-9 p-4 bg-white mt-4 rounded-3" style={{ marginBottom: '95px' }}>
                            <div class="row my-4">
                                <div class="col-md-4">
                                    <label class="form-label hive-form-label" for="department">
                                        Department <span class="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        value={concernDetails?.departmentID}
                                        name="departmentID"
                                        onChange={(e) => {
                                            handleInput(e);
                                        }}
                                        class="form-select hive-form-select"
                                        id="department"
                                    >
                                        <option value="Selected">Select</option>
                                        {bindDepartment()}
                                    </select>
                                    <span className="text-danger">{departmentValidation}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label hive-form-label" for="person-name">
                                        Feedback about Whom <span class="required">*</span>
                                    </label>
                                    <Select
                                        className="dropdown"
                                        name="againstWhom"
                                        maxMenuHeight={100}
                                        placeholder="Select"
                                        value={SelectedPeopleList}
                                        options={peoplePickerData} // set list of the data
                                        onChange={(e) => {
                                            handleChange(e);
                                        }} // assign onChange function
                                        isMulti
                                        isClearable
                                    />
                                    <span className="text-danger">{personValidation}</span>
                                </div>
                            </div>
                            <div class="col-md-12 mb-5">
                                <label class="form-label hive-form-label" for="description">
                                    Feedback <span class="required">*</span>
                                </label>
                                <textarea
                                    name="description"
                                    value={concernDetails?.description}
                                    onChange={(e) => {
                                        handleInput(e);
                                    }}
                                    class="custom-comment-box hive-form-control custom-textfield form-control p-2"
                                    maxLength={255}
                                    min="0"
                                    max="254"
                                    placeholder="Share your feedback in detail."
                                    id="description"
                                ></textarea>
                                <span className="text-danger">{descriptionValidation}</span>
                            </div>
                            <div class="col-md-12 d-flex justify-content-end mb-4">
                                <button
                                    onClick={() => {
                                        redirect();
                                    }}
                                    class="btn hive-btn-secondary bold-text me-2"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        validation();
                                    }}
                                    class="btn hive-btn-primary"
                                    disabled={disabledCheck}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {type == 2 ? (
                        <div class="col-md-9 p-4 bg-white mt-4 rounded-3" style={{ marginBottom: '95px' }}>
                            <div class="row my-4">
                                <div class="col-md-4">
                                    <label class="form-label hive-form-label" for="department">
                                        Department <span class="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        value={concernDetails?.departmentID}
                                        name="departmentID"
                                        onChange={(e) => {
                                            handleInput(e);
                                        }}
                                        class="form-select hive-form-select"
                                        id="department"
                                    >
                                        <option value="Selected">Select</option>
                                        {bindDepartment()}
                                    </select>
                                    <span className="text-danger">{departmentValidation}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label hive-form-label" for="person-name">
                                        Concern about Whom <span class="required">*</span>
                                    </label>
                                    <Select
                                        className="dropdown"
                                        name="againstWhom"
                                        maxMenuHeight={100}
                                        placeholder="Select"
                                        value={SelectedPeopleList}
                                        options={peoplePickerData} // set list of the data
                                        onChange={(e) => {
                                            handleChange(e);
                                        }} // assign onChange function
                                        isMulti
                                        isClearable
                                    />
                                    <span className="text-danger">{personValidation}</span>
                                </div>
                            </div>
                            <div class="col-md-12 mb-5">
                                <label class="form-label hive-form-label" for="concern-description">
                                    Concern Description <span class="required">*</span>
                                </label>
                                <textarea
                                    name="description"
                                    value={concernDetails?.description}
                                    onChange={(e) => {
                                        handleInput(e);
                                    }}
                                    class="custom-comment-box hive-form-control custom-textfield form-control p-2"
                                    maxLength={255}
                                    min="0"
                                    max="254"
                                    placeholder="Tell us more about your Concern"
                                    id="concern-description"
                                ></textarea>
                                <span className="text-danger">{descriptionValidation}</span>
                            </div>
                            <div class="col-md-12 d-flex justify-content-end mb-4">
                                <button
                                    onClick={() => {
                                        redirect();
                                    }}
                                    class="btn hive-btn-secondary bold-text me-2"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        validation();
                                    }}
                                    class="btn hive-btn-primary"
                                    disabled={disabledCheck}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {type == 3 ? (
                        <div className="col-md-9 p-4 bg-white mt-4 rounded-3" style={{ marginBottom: '95px' }}>
                            {/*Form structure starts Here*/}
                            <label id="victim" className="form-label hive-form-label mb-3">
                                Who is the victim? <span className="required">*</span>
                            </label>
                            <div className="d-flex">
                                <input
                                    onClick={(e) => {
                                        handleVictim(e);
                                    }}
                                    type="radio"
                                    className="me-2 mt-0 form-check-input custom-radio-btn"
                                    value="1"
                                    checked={victimType === '1' ? true : false}
                                    name="victim"
                                    id="myself"
                                />
                                <label className="form-check-label font-13 semibold-text me-3" htmlFor="myself">
                                    Myself
                                </label>
                                <input
                                    onClick={(e) => {
                                        handleVictim(e);
                                    }}
                                    type="radio"
                                    className="me-2 mt-0 form-check-input custom-radio-btn"
                                    value="2"
                                    checked={victimType === '2' ? true : false}
                                    id="my_friend"
                                    name="victim"
                                />
                                <label className="form-check-label font-13 semibold-text me-3" htmlFor="my_friend">
                                    My friend
                                </label>
                            </div>
                            <div className="row my-4">
                                {victimType == 1 ? (
                                    <>
                                        <div hidden={true} className="col-md-4">
                                            <label className="form-label hive-form-label" htmlFor="department">
                                                Department <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                value={concernDetails?.departmentID}
                                                name="departmentID"
                                                onChange={(e) => {
                                                    handleInput(e);
                                                }}
                                                className="form-select hive-form-select"
                                                id="department"
                                            >
                                                <option value="Selected">Select</option>
                                                {bindDepartment()}
                                            </select>
                                            <span className="text-danger">{departmentValidation}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label" htmlFor="person-name">
                                                People Involved in the incident <span className="required">*</span>
                                            </label>
                                            <Select
                                                className="dropdown"
                                                name="againstWhom"
                                                maxMenuHeight={100}
                                                placeholder="Select"
                                                value={SelectedPeopleList}
                                                options={peoplePickerData} // set list of the data
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }} // assign onChange function
                                                isMulti
                                                isClearable
                                            />
                                            <span className="text-danger ">{personValidation}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label" htmlFor="date">
                                                Date <span className="required">*</span>
                                            </label>
                                            <input
                                                name="incidentDate"
                                                value={concernDetails?.incidentDate}
                                                onChange={(e) => {
                                                    handleInput(e);
                                                }}
                                                type="date"
                                                max={maxDate}
                                                className="form-control hive-form-control"
                                                placeholder="Select the date"
                                                id="date"
                                            />
                                            <span className="text-danger ">{dateValidation}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label" htmlFor="location">
                                                Location <span className="required">*</span>
                                            </label>
                                            <input
                                                name="location"
                                                value={concernDetails?.location}
                                                onChange={(e) => {
                                                    handleInput(e);
                                                }}
                                                type="text"
                                                className="form-control hive-form-control"
                                                maxLength={255}
                                                min="0"
                                                max="254"
                                                placeholder="Enter the location"
                                                id="location"
                                            />
                                            <span className="text-danger">{locationValidation}</span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div hidden={false} className="col-md-4">
                                            <label className="form-label hive-form-label" htmlFor="department">
                                                Department <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                value={concernDetails?.departmentID}
                                                name="departmentID"
                                                onChange={(e) => {
                                                    handleInput(e);
                                                }}
                                                className="form-select hive-form-select"
                                                id="department"
                                            >
                                                <option value="Selected">Select</option>
                                                {bindDepartment()}
                                            </select>
                                            <span className="text-danger">{departmentValidation}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label" htmlFor="person-name">
                                                Friend Name <span className="required">*</span>
                                            </label>
                                            {}
                                            <Select
                                                className="dropdown"
                                                name="victimName"
                                                maxMenuHeight={100}
                                                placeholder="Select"
                                                value={selectedFriend}
                                                options={peoplePickerData} // set list of the data
                                                onChange={(e) => {
                                                    handleOnChange(e);
                                                }} // assign onChange function
                                                isMulti
                                                isClearable
                                            />
                                            <span className="text-danger">{friendNameValidation}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label hive-form-label" htmlFor="people-involed">
                                                People Involved <span className="required">*</span>
                                            </label>
                                            <Select
                                                className="dropdown"
                                                name="againstWhom"
                                                maxMenuHeight={100}
                                                placeholder="Select"
                                                value={SelectedPeopleList}
                                                options={peoplePickerData} // set list of the data
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }} // assign onChange function
                                                isMulti
                                                isClearable
                                            />
                                            <span className="text-danger">{personValidation}</span>
                                        </div>
                                        <div className="col-md-4 mt-3">
                                            <label className="form-label hive-form-label" htmlFor="location">
                                                Location <span className="required">*</span>
                                            </label>
                                            <input
                                                name="location"
                                                value={concernDetails?.location}
                                                onChange={(e) => {
                                                    handleInput(e);
                                                }}
                                                type="text"
                                                className="form-control hive-form-control custom-textfield"
                                                maxLength={255}
                                                min="0"
                                                max="254"
                                                placeholder="Enter the location"
                                                id="location"
                                            />
                                            <span className="text-danger">{locationValidation}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="col-md-12 mb-5">
                                <label className="form-label hive-form-label" htmlFor="concern-description">
                                    Description of the incident <span className="required">*</span>
                                </label>
                                <textarea
                                    name="description"
                                    value={concernDetails?.description}
                                    onChange={(e) => {
                                        handleInput(e);
                                    }}
                                    className="custom-comment-box hive-form-control custom-textfield form-control p-2"
                                    maxLength={255}
                                    min="0"
                                    max="254"
                                    placeholder="Describe the incident in detail"
                                    id="concern-description"
                                />
                                <span className="text-danger">{descriptionValidation}</span>
                            </div>
                            <div className="col-md-12 d-flex justify-content-end mb-4">
                                <button
                                    onClick={() => {
                                        redirect();
                                    }}
                                    className="btn hive-btn-secondary bold-text me-2"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        validation();
                                    }}
                                    className="btn hive-btn-primary"
                                    disabled={disabledCheck}
                                >
                                    Submit
                                </button>
                            </div>
                            {/*Form structure ends Here*/}
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(ConcernForm);